import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardWithForcedLogin, RoleGuard } from '@telus/d2c-core/auth';

const routes: Routes = [
  {
    path: '',
    //loadChildren: () =>
    //  import('./pages/intro/intro.module').then((m) => m.IntroModule),
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'app',
    canActivate: [AuthGuardWithForcedLogin],
    canActivateChild: [AuthGuardWithForcedLogin],
    loadChildren: () =>
      import('./pages/d2c-central/main-page/main-page.module').then(
        (m) => m.MainModule
      ),
  },
  //{ path: '**', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '**',
    loadChildren: () =>
      import('./pages/d2c-central/error-page/error.module').then(
        (m) => m.ErrorModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
